class EditBioController {
    /* @ngInject */

  constructor (UsersService, $mdDialog, $mdToast, user) {
    this.UsersService = UsersService
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.user = { ...user }
  }

  updateUser () {
    this.UsersService.updateUser({
      userInfo: this.user
    })
            .then(() => {
              this.$mdDialog.hide(this.user.bio)
              this.$mdToast.show(
                    this.$mdToast.simple('Changes saved.')
                        .hideDelay(5000)
                )
            })
            .catch((err) => {
              this.$mdToast.showSimple('Failed to update profile info')
            })
  }

  closeDialog () {
    this.$mdDialog.cancel()
  }
}

export default EditBioController
